import { HideLoader, ShowLoader } from './loader.action';
import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { isString } from '@services/utils/type-checkers';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class LoaderEffects {
  constructor(private actions$: Actions) {}

  showLoader$ = createEffect(() =>
    this.actions$.pipe(
      filter((action: any) => (action && action.showLoader ? action : null)),
      map(
        (action: any) =>
          new ShowLoader(
            isString(action.showLoader)
              ? { ...action, type: action.showLoader }
              : action,
          ),
      ),
    ),
  );

  hideLoader$ = createEffect(() =>
    this.actions$.pipe(
      filter((action: any) => {
        return (action && action.triggerAction ? action : null)
      }),
      map((action: any) => new HideLoader(action)),
    ),
  );
}
